import { Button, ClickEvent, DataSourceMode, Layout, SlideoutDecorator, TableSelectionEvent, Toast } from "@mcleod/components";
import { AutogenLayoutCarrierPerfCalculationCleanup } from "./autogen/AutogenLayoutCarrierPerfCalculationCleanup";
import { Api, ModelRow } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";

export class CarrierPerfCalculationCleanup extends AutogenLayoutCarrierPerfCalculationCleanup {

    tableCarrierPerfCalculationsOnSelect(event: TableSelectionEvent) {
        const selectedRows = this.tableCarrierPerfCalculations.selectedRowCount;
        this.labelCalculationCount.text = selectedRows.toString();
    }
    
    static async showSlideout(): Promise<SlideoutDecorator> {
        const response = await Api.search("lme/powerbroker/carrier-performance-cleanup");
        const layout = Layout.getLayout("lme/powerbroker/CarrierPerfCalculationCleanup") as CarrierPerfCalculationCleanup;    
        layout.addLayoutLoadListener(() => {
            const modelRows = response.data.map(item => new ModelRow(null, false, item));
            layout.sourceCarrierPerfCalculations.setRowsAndMode(DataSourceMode.NONE, modelRows);
        });
        const deleteAndClose = new Button({
            caption: "Delete & Close",
            backgroundColor: "primary",
            color: "default.reverse",
            borderWidth: 0,
            rowBreak: false,
            onClick: async (event: ClickEvent) => {
                //doSomething
                const batchNumbers = layout.tableCarrierPerfCalculations.selectedRows
                                    .map(row => (row.data as ModelRow).getNumber("batch_number"));
                if (batchNumbers.length > 0) {
                    const proceed = await CommonDialogs.showYesNo(
                        `Are you sure you would like to delete ${batchNumbers.length} date(s)?\n\nThis action cannot be undone.`,
                        `${batchNumbers.length} date(s) will be deleted`
                    );
                    if (proceed) {
                        const response = await Api.post("lme/powerbroker/carrier-performance-cleanup", { "batch_numbers": batchNumbers });
                        await decorator.slideOut();
                        return Toast.showSuccessToast("Cleanup was successful.");
                    }
                } else {
                    return decorator.slideOut();
                }
            }
        })
        const decorator = new SlideoutDecorator({
            layout: layout,
            fillHeight: true,
            title: "Cleanup Scorecard Data",
            width: 500,
            overlayProps: {
                greyedBackground: true,
                closeOnClickOff: true
            },
            addlComponents: [deleteAndClose],
            onClose: () => decorator.slideOut()
        });
        return decorator;
    }
}